import { connect, MapStateToProps, MapDispatchToProps } from 'react-redux';
import { Props } from './DeviationPage';
import { DeviationPageStoreSlice } from './redux/types';
import {
  loadDeviation,
  fullscreenEntered,
  fullscreenExited,
  setScreenSize,
} from './redux/actions';
import { getEffectiveViewMode } from './redux/selectors';

export type StateProps = Pick<Props, 'deviation' | 'viewMode'>;
export type DispatchProps = Pick<
  Props,
  'onLoad' | 'onFullscreenEntered' | 'onFullscreenExited' | 'onScreenResize'
>;
export type OwnProps = Omit<
  Props,
  keyof Omit<StateProps & DispatchProps, 'deviation'>
>;

const mapStateToProps: MapStateToProps<
  StateProps,
  OwnProps,
  DeviationPageStoreSlice
> = (state, ownProps) => ({
  viewMode: getEffectiveViewMode(state, ownProps.deviation),
});
const mapDispatchToProps: MapDispatchToProps<DispatchProps, OwnProps> = {
  onLoad: loadDeviation,
  onFullscreenEntered: fullscreenEntered,
  onFullscreenExited: fullscreenExited,
  onScreenResize: setScreenSize,
};

export default connect(mapStateToProps, mapDispatchToProps);
